function onAdBlockLoad() {
    typeof window !== 'undefined' && window.dispatchEvent(new CustomEvent('AD_BLOCK_STATUS', {detail: {isAdBlocked: false}}));
}

function onAdBlockError() {
    typeof window !== 'undefined' && window.dispatchEvent(new CustomEvent('AD_BLOCK_STATUS', {detail: {isAdBlocked: true}}));
}

export const ADS_LOADER_PROD = {
    adsLoader: {
        src: 'https://www.uciservice.com/assets/meso-loaders/ads-loader.js',
        id: 'ads-loader',
        type: 'module'

    },
    adBlockTest: {
        id: 'ad-block-test',
        src: 'https://www.uciservice.com/assets/meso-loaders/expads-blocked.js',
        onload: onAdBlockLoad,
        onerror: onAdBlockError
    },
};

export const ADS_LOADER_DEVELOPMENT = {
    adsLoader: {
        src: 'https://www.uciservice.com/assets-int/meso-loaders/ads-loader.js',
        id: 'ads-loader',
        type: 'module'

    },
    adBlockTest: {
        id: 'ad-block-test',
        src: 'https://www.uciservice.com/assets-int/meso-loaders/expads-blocked.js',
        onload: onAdBlockLoad,
        onerror: onAdBlockError
    }
};

export const getAdsLoaderScripts = (env) => {
    if (env === 'development') {
        return ADS_LOADER_DEVELOPMENT;
    }

    return ADS_LOADER_PROD;
};

const addScript = (props) => {
    const script = document.createElement('script');
    Object.entries(props).forEach(([key, value]) => script[key] = value);
    document.body.appendChild(script);
    return script;
}

export const insertAdBlockTestScript = () => {
    const config = getAdsLoaderScripts(process.env.NODE_ENV);
    const adBlockTestIdScript = document.getElementById(config.adBlockTest.id);
    if (!adBlockTestIdScript) {
        addScript(config.adBlockTest);
    }
}

export const insertAdsLoaderScripts = () => {
    const {adsLoader} = getAdsLoaderScripts(process.env.NODE_ENV);
    !document.getElementById(adsLoader.id) && addScript(adsLoader);
}

export const removeAdsScripts = () => {
    const {adsLoader, adBlockTest} = getAdsLoaderScripts(process.env.NODE_ENV);
    const ids = [adsLoader.id, adBlockTest.id]
    ids.forEach((id) => {
        const script = document.getElementById(id);
        if (script) {
            script.remove();
        }
    });
}
